/*
 * newsbot - Sources section for filter details
 * Match or exclude stories by source domain
 */

import { useFormikContext } from "formik";
import { CollapsibleSection, FilterLayoutClass, FilterTightGridGapClass } from "@/components/filters/_components";
import { TextAreaAutoResize } from "@/components/inputs/input";
import { Select } from "@/components/inputs/select";
import { classNames } from "@utils";

const matchLogicOptions = [
  { label: "Match ANY source", value: "ANY" },
  { label: "Match ALL sources", value: "ALL" },
];

interface SourcesFormValues {
  match_sources: string;
  except_sources: string;
  sources_match_logic: 'ANY' | 'ALL';
  sources_except_logic: 'ANY' | 'ALL';
}

export const Sources = () => {
  const { values } = useFormikContext<SourcesFormValues>();

  return (
    <CollapsibleSection
      defaultOpen={values.match_sources?.length > 0 || values.except_sources?.length > 0}
      title="Sources"
      subtitle="Match or exclude stories by source domain"
    >
      <div className={classNames("sm:col-span-6", FilterLayoutClass, FilterTightGridGapClass)}>
        <TextAreaAutoResize
          name="match_sources"
          label="Match sources"
          columns={8}
          placeholder="reuters.com, bbc.com, nytimes.com"
          tooltip={<p>Comma-separated source domains to match</p>}
        />
        <Select
          name="sources_match_logic"
          label="Match logic"
          columns={4}
          options={matchLogicOptions}
          optionDefaultText="any"
        />
      </div>
      <div className={classNames("sm:col-span-6", FilterLayoutClass, FilterTightGridGapClass)}>
        <TextAreaAutoResize
          name="except_sources"
          label="Except sources"
          columns={8}
          placeholder="tabloid.com, spam-news.com"
          tooltip={<p>Stories from these sources are excluded</p>}
        />
        <Select
          name="sources_except_logic"
          label="Except logic"
          columns={4}
          options={matchLogicOptions}
          optionDefaultText="any"
        />
      </div>
    </CollapsibleSection>
  );
};
